<template>
  <div v-if="visible">
    <div
      class="modal custom-modal fade show"
      style="display:block;z-index:1060;"
      role="dialog"
      aria-modal="true"
      aria-labelledby="admin-verify-title"
      @click.self="onBackdropClick"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="admin-verify-title">
              <i class="fa fa-shield m-r-5 text-primary"></i> Verifikasi Administrator
            </h5>
            <button
              type="button"
              class="close"
              aria-label="Tutup"
              :disabled="loading"
              @click="close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit.prevent="submit">
            <div class="modal-body">
              <p class="text-muted">
                Untuk alasan keamanan, masukkan password akun administrator Anda
                sebelum melanjutkan.
              </p>

              <div v-if="memberName" class="alert alert-light border py-2">
                <small class="text-muted d-block">Member yang dipilih</small>
                <strong>{{ memberName }}</strong>
                <span v-if="actionLabel" class="text-muted"> &middot; {{ actionLabel }}</span>
              </div>

              <div class="form-group">
                <label for="admin-verify-password">Password Admin</label>
                <div class="input-group">
                  <input
                    id="admin-verify-password"
                    ref="passwordInput"
                    v-model="password"
                    class="form-control"
                    :type="showPassword ? 'text' : 'password'"
                    placeholder="Masukkan password administrator"
                    autocomplete="current-password"
                    :disabled="loading"
                  />
                  <div class="input-group-append">
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      :disabled="loading"
                      :aria-label="showPassword ? 'Sembunyikan password' : 'Tampilkan password'"
                      @click="showPassword = !showPassword"
                    >
                      <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </button>
                  </div>
                </div>
                <small class="form-text text-muted">
                  Gunakan password akun Zeus/administrator, bukan password member.
                </small>
              </div>

              <div v-if="errorMessage" class="alert alert-danger mb-0" role="alert">
                <i class="fa fa-exclamation-circle m-r-5"></i>{{ errorMessage }}
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-light"
                :disabled="loading"
                @click="close"
              >
                Batal
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="loading || password.length === 0"
              >
                <span v-if="loading">
                  <i class="fa fa-spinner fa-spin"></i> Memproses...
                </span>
                <span v-else>
                  <i class="fa fa-lock"></i> Verifikasi &amp; Lanjutkan
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" style="z-index:1055;"></div>
  </div>
</template>

<script>
export default {
  name: "ModalAdminPasswordVerify",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    },
    memberName: {
      type: String,
      default: ""
    },
    actionLabel: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      password: "",
      showPassword: false
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.password = "";
        this.showPassword = false;
        this.$nextTick(() => {
          if (this.$refs.passwordInput) {
            this.$refs.passwordInput.focus();
          }
        });
      } else {
        this.password = "";
        this.showPassword = false;
      }
    }
  },
  mounted() {
    document.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeydown);
    this.password = "";
  },
  methods: {
    onKeydown(event) {
      if (event.key === "Escape" && this.visible) {
        this.close();
      }
    },
    onBackdropClick() {
      this.close();
    },
    close() {
      if (this.loading) {
        return;
      }
      this.password = "";
      this.showPassword = false;
      this.$emit("close");
    },
    submit() {
      if (this.loading || this.password.length === 0) {
        return;
      }
      // Password dikirim ke parent sebagai argumen, tidak disimpan di state
      // global/localStorage/sessionStorage dan langsung dibersihkan.
      const password = this.password;
      this.password = "";
      this.showPassword = false;
      this.$emit("submit", password);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ModalAdminPasswordVerify.vue